import { gql } from "@apollo/client";

const TOP_ACCOUNTS_FRAGMENT = gql`
  fragment topAccountsData on Top10VulnerableCloudAccountsDataType {
    widget_definition_key
    data {
      cloud_account
      count_by_severity
      sources
      provider
      total_count
    }
    metadata
  }
`;

export const GET_TOP_ACCOUNTS_DATA = gql`
  ${TOP_ACCOUNTS_FRAGMENT}
  query getTopAccountsData(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...topAccountsData
    }
  }
`;

const TOP_REPOS_FRAGMENT = gql`
  fragment topReposData on Top10VulnerableRepositoriesDataType {
    widget_definition_key
    data {
      repository
      count_by_severity
      sources
      provider
      total_count
    }
    metadata
  }
`;

export const GET_TOP_REPOS_DATA = gql`
  ${TOP_REPOS_FRAGMENT}
  query getTopReposData(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...topReposData
    }
  }
`;

const TOP_PACKAGES_FRAGMENT = gql`
  fragment topPackagesData on Top10VulnerablePackagesDataType {
    widget_definition_key
    data {
      package
      count_by_severity
      sources
      provider
      total_count
      resources
    }
    metadata
  }
`;

export const GET_TOP_PACKAGES_DATA = gql`
  ${TOP_PACKAGES_FRAGMENT}
  query getTopPackagesData(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...topPackagesData
    }
  }
`;

const TOP_FIXES_FRAGMENT = gql`
  fragment topFixesData on Top10FixesDataType {
    widget_definition_key
    data {
      fix
      count_by_severity
      sources
      total_count
      resources
    }
    metadata
  }
`;

export const GET_TOP_FIXES_DATA = gql`
  ${TOP_FIXES_FRAGMENT}
  query getTopFixesData(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...topFixesData
    }
  }
`;

// inventory widgets

const INVENTORY_FINDINGS_BY_DATASOURCES_FRAGMENT = gql`
  fragment inventoryDataSourcesFragment on InventoryFindingsByDatasourceDataType {
    data {
      source
      findings
      related_members
    }
    metadata
    widget_definition_key
  }
`;

export const GET_INVENTORY_FINDINGS_BY_DATASOURCES = gql`
  ${INVENTORY_FINDINGS_BY_DATASOURCES_FRAGMENT}
  query getInventoryFindingsByDatasources(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...inventoryDataSourcesFragment
    }
  }
`;

const INVENTORY_CLOUD_ACCOUNTS_FRAGMENT = gql`
  fragment inventoryCloudAccountsFragment on InventoryCloudAccountsByProviderDataType {
    data {
      provider
      resources_count
    }
    metadata
    widget_definition_key
  }
`;

export const GET_INVENTORY_CLOUD_ACCOUNTS = gql`
  ${INVENTORY_CLOUD_ACCOUNTS_FRAGMENT}
  query getInventoryCloudAccounts(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...inventoryCloudAccountsFragment
    }
  }
`;

const INVENTORY_CODE_REPO_FRAGMENT = gql`
  fragment inventoryRepositoriesFragment on InventoryCodeRepositoryByPlatformDataType {
    data {
      platform
      resources_count
    }
    metadata
    widget_definition_key
  }
`;

export const GET_INVENTORY_CODE_REPOSITORIES = gql`
  ${INVENTORY_CODE_REPO_FRAGMENT}
  query getInventoryCodeRepositories(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...inventoryRepositoriesFragment
    }
  }
`;

const INVENTORY_THREAT_INTEL_FRAGMENT = gql`
  fragment inventoryThreatIntelligenceFragment on InventoryFindingsByThreatIntelType {
    data
    metadata
    widget_definition_key
  }
`;

export const GET_INVENTORY_THREAT_INTEL = gql`
  ${INVENTORY_THREAT_INTEL_FRAGMENT}
  query getInventoryThreatIntel(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...inventoryThreatIntelligenceFragment
    }
  }
`;

const QUEUE_SUMMARY_FRAGMENT = gql`
  fragment queueSummary on RmqsCountByEndpointType {
    data
    metadata
    widget_definition_key
  }
`;

export const GET_QUEUE_SUMMARY = gql`
  ${QUEUE_SUMMARY_FRAGMENT}
  query getQueueSummary(
    $widget_definition_key: WidgetDefinitionKey!
    $filters_config: FiltersConfigInput!
  ) {
    generic_widget_data(
      widget_definition_key: $widget_definition_key
      filters_config: $filters_config
    ) {
      ...queueSummary
    }
  }
`;
